import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { MagicCard } from '@/components/lib/magicui/MagicCard';
import { useRevealOnce } from '@/hooks/useRevealOnce';
import { gridContainerVariants, getGridItemVariants } from '@/lib/animations';

interface Category {
  label: string;
  slug: string;
}

const CATEGORIES: Category[] = [
  { label: 'Accounting', slug: 'accounting' },
  { label: 'Legal', slug: 'legal' },
  { label: 'Branding', slug: 'branding' },
  { label: 'Marketing', slug: 'marketing' },
  { label: 'Design', slug: 'design' },
  { label: 'Development', slug: 'development' },
  { label: 'HR', slug: 'hr' },
  { label: 'Support', slug: 'support' },
  { label: 'Consulting', slug: 'consulting' },
  { label: 'Finance', slug: 'finance' },
  { label: 'Analytics', slug: 'analytics' },
  { label: 'Training', slug: 'training' },
  { label: 'Freelancing', slug: 'freelancing' },
  { label: 'Sales', slug: 'sales' },
];

export function ExploreCategoriesStrip() {
  const categoriesReveal = useRevealOnce({ amount: 0.25 });

  return (
    <motion.div
      ref={categoriesReveal.ref}
      className="mt-8 md:mt-12 px-4"
      variants={gridContainerVariants}
      initial="hidden"
      animate={categoriesReveal.controls}
    >
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-6 w-full">
        {CATEGORIES.map((category, index) => (
          <motion.div
            key={category.slug}
            variants={getGridItemVariants(index)}
            className="h-full"
          >
            <Link
              to={`/categories/${category.slug}`}
              className="block h-full focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 rounded-xl group"
            >
              <MagicCard
                className="h-full min-h-[140px] md:min-h-[160px] lg:min-h-[180px] !bg-white !border-slate-200 group-hover:!border-[#0000FF] transition-all duration-300 shadow-lg group-hover:shadow-xl group-hover:shadow-blue-500/30"
                containerClassName="h-full"
                glowColor="rgba(0, 0, 255, 0.3)"
                borderGlowColor="rgba(0, 0, 255, 0.7)"
              >
                <div className="h-full flex items-center justify-center p-6 md:p-8 lg:p-10 relative overflow-hidden">
                  {/* Semi-transparent blue overlay on hover to make white text visible while keeping gradient glow */}
                  <div className="absolute inset-0 bg-[#0000FF] opacity-0 group-hover:opacity-60 transition-opacity duration-300 rounded-xl pointer-events-none z-0" />
                  <span className="text-xl md:text-2xl lg:text-3xl font-bold text-slate-900 group-hover:text-white transition-colors duration-300 text-center relative z-10">
                    {category.label}
                  </span>
                </div>
              </MagicCard>
            </Link>
          </motion.div>
        ))}
      </div>
    </motion.div>
  );
}

